// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"31215617","181":"7efb8939","218":"34ede947","316":"e1ba8ced","607":"ea00748c","633":"e509813a","744":"0ae56515","751":"953de64b","944":"e6d5732c","996":"d445e85d"}[chunkId] + ".chunk.js";
};